import React, { Fragment, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Grid,
  GridCell,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
  TEXT_VARIANT_BOLD,
  Text,
} from 'mailup-web-components'

import InputAddField from 'Pages/RecipientsList/components/insert/InputAddField'

import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'

const BoxAddDynamicFields: FC = () => {
  const intl = useIntl()

  const dynamicFields = useRecoilValue(dynamicFieldsState)

  return (
    <Flex flexDirection="column" gap="16px" margin="16px 0 0 0">
      <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
        {intl.formatMessage(
          {
            id: 'Load.RecipientsList.DynamicFieldsLimitInfo',
          },
          {
            PATHSEP: '>',
          },
        )}
      </MessageBox>

      <Grid cols={12} variantVertical="0px">
        {dynamicFields.map(({ id, description }) => (
          <Fragment key={id}>
            <GridCell span={5}>
              <Flex alignItems="flex-start" gap="16px" minHeight="36px">
                <FlexItem flexBasis="16px" padding="10px 0">
                  <Text variant={TEXT_VARIANT_BOLD}>{id}</Text>
                </FlexItem>
                <FlexItem padding="10px 0">
                  <Text variant={TEXT_VARIANT_BOLD} wordBreak="break-all">
                    {description}
                  </Text>
                </FlexItem>
              </Flex>
            </GridCell>
            <GridCell span={7}>
              <InputAddField fieldId={id} />
            </GridCell>
          </Fragment>
        ))}
      </Grid>
    </Flex>
  )
}

export default BoxAddDynamicFields
